<template>
  <div class="main-menu-content">
    <ul
      v-if="currentRouteName && currentRouteName[0] === 'settings'"
      class="navigation navigation-main"
      id="main-menu-navigation"
      data-menu="menu-navigation"
    >
      <li class="navigation-header mt-1"><span>Настройки</span></li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'settings.project' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-box" /><span
            class="menu-title text-truncate"
            >Проекты</span
          ></router-link
        >
      </li>
    </ul>

    <ul
      v-if="
        project_mode !== 'vityaz' &&
        currentRouteName &&
        currentRouteName[0] === 'journals'
      "
      class="navigation navigation-main"
      id="main-menu-navigation"
      data-menu="menu-navigation"
    >
      <li class="navigation-header mt-1"><span>Журналы</span></li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'journals.21' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-box" /><span
            class="menu-title text-truncate"
            >Оценки соответствия</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'journals.77' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-box" /><span
            class="menu-title text-truncate"
            >Аттестации</span
          ></router-link
        >
      </li>
    </ul>

    <ul
      v-if="
        project_mode !== 'vityaz' &&
        currentRouteName &&
        currentRouteName[0] === 'protocols'
      "
      class="navigation navigation-main"
      id="main-menu-navigation"
      data-menu="menu-navigation"
    >
      <li class="navigation-header mt-1"><span>Протоколы</span></li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'protocols.work' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-box" /><span
            class="menu-title text-truncate"
            >Генерация</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'protocols.template' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-box" /><span
            class="menu-title text-truncate"
            >Шаблоны</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'protocols.settings' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-box" /><span
            class="menu-title text-truncate"
            >Настройки</span
          ></router-link
        >
      </li>
    </ul>

    <ul
      v-if="currentRouteName && currentRouteName[0] === 'project'"
      class="navigation navigation-main"
      id="main-menu-navigation"
      data-menu="menu-navigation"
    >
      <li class="navigation-header mt-1"><span>Проект</span></li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'project.organization' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-home" /><span
            class="menu-title text-truncate"
            >Организации</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'project.pack' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-star" /><span
            class="menu-title text-truncate"
            >Пакеты</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'project.template' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-file-contract" /><span
            class="menu-title text-truncate"
            >Шаблоны</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'project.field' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-keyboard" /><span
            class="menu-title text-truncate"
            >Поля в документах</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'project.category' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-list" /><span
            class="menu-title text-truncate"
            >Категории полей</span
          ></router-link
        >
      </li>
      <li class="nav-item">
        <router-link
          :to="{ name: 'project.folder' }"
          class="d-flex align-items-center"
          ><font-awesome-icon icon="fas fa-list" /><span
            class="menu-title text-truncate"
            >Папки для шаблонов</span
          ></router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      project_mode: process.env.MIX_PROJECT_MODE || "uib",
    };
  },
  computed: {
    currentRouteName() {
      if (this.$route.name) {
        return this.$route.name.split(".");
      }
    },
  },
};
</script>
